import React, { useState, useEffect } from 'react';
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import AccountsMenu from './AccountsMenu';
import { NavLink } from 'react-router-dom';
import YearsDropDown from '../Shared/YearsDropDown';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import { scrollToTop } from '../Shared/ScrollOnTop';

function ReceiptPayment(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [DefaultFYear, setDefaultFYear] = useState(localStorage.getItem("DefaultFYear"));
    const [loading, setLoading] = useState(false);
    const [listOfOpening, setListOfOpening] = useState([]);
    const [listOfReceipts, setListOfReceipts] = useState([]);
    const [listOfPayments, setListOfPayments] = useState([]);
    const [listOfClosing, setListOfClosing] = useState([]);
    const [ClosingDebitTotal, setClosingDebitTotal] = useState("");
    const [ClosingCreditTotal, setClosingCreditTotal] = useState("");
    const [isBalanced, setIsBalanced] = useState(null);
    const [balanceDifference, setBalanceDifference] = useState("");
    const [head05ClosingDebit, setHead05ClosingDebit] = useState("");
    const [head05ClosingCredit, setHead05ClosingCredit] = useState("");
    const [totalMessage, setTotalMessage] = useState("");
    const [AccountLevel, setAccountLevel] = useState("1");
    const [EndDate, setEndDate] = useState("");
    const [showZeroAccounts, setShowZeroAccounts] = useState(false);
    const [showThirdOnly, setShowThirdOnly] = useState(false);
    const [searchTrigger, setSearchTrigger] = useState(0);

    useEffect(() => {

        document.title = "Receipt Payment Account";
    }, []);

    useEffect(() => {
        if (!DefaultFYear) {
            return;
        }
        const fy = parseInt(String(DefaultFYear).trim(), 10);
        if (!Number.isFinite(fy) || fy <= 0) {
            return;
        }
        const fyStart = moment(`${fy}-04-01`);
        const fyEnd = moment(`${fy + 1}-03-31`);
        const today = moment();
        const defaultEnd = today.isBetween(fyStart, fyEnd, "day", "[]") ? today : fyEnd;
        const defaultEndStr = defaultEnd.format(config.date_format_input);

        const endMoment = EndDate ? moment(EndDate, config.date_format_input, true) : null;
        const endIsValid = endMoment
            && endMoment.isValid()
            && !endMoment.isBefore(fyStart, "day")
            && !endMoment.isAfter(fyEnd, "day");

        if (!endIsValid) {
            if (EndDate !== defaultEndStr) {
                setEndDate(defaultEndStr);
                return;
            }
        }

        const effectiveEndDate = endIsValid ? EndDate : defaultEndStr;
        setTotalMessage("");
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            FYear: fy,
            EndDate: effectiveEndDate,
            AccountLevel: parseInt(String(AccountLevel).trim(), 10) || 1,
            ShowZeroAccounts: showZeroAccounts,
            ShowThirdOnly: showThirdOnly

        };

        //console.log(data);

        var api_config = {
            method: 'post',
            url: config.base_url + 'Accounts/GetReceiptPayment',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code === 1) {
                    const opening = response.data.ListofOpening || [];
                    const receipts = response.data.ListofReceipts || [];
                    const payments = response.data.ListofPayments || [];
                    const closing = response.data.ListofClosing || [];
                    setListOfOpening(opening);
                    setListOfReceipts(receipts);
                    setListOfPayments(payments);
                    setListOfClosing(closing);
                    setClosingDebitTotal(response.data.ClosingDebitTotal || "");
                    setClosingCreditTotal(response.data.ClosingCreditTotal || "");
                    setIsBalanced(response.data.IsBalanced === true);
                    setBalanceDifference(response.data.BalanceDifference || "");
                    setHead05ClosingDebit(response.data.Head05ClosingDebit || "");
                    setHead05ClosingCredit(response.data.Head05ClosingCredit || "");
                    const hasRows = opening.length + receipts.length + payments.length + closing.length > 0;
                    setTotalMessage(
                        hasRows
                            ? ""
                            : "No accounts with activity found. Try enabling Show Zero Accounts or a different level."
                    );
                }
                else {
                    setListOfOpening([]);
                    setListOfReceipts([]);
                    setListOfPayments([]);
                    setListOfClosing([]);
                    setClosingDebitTotal("");
                    setClosingCreditTotal("");
                    setIsBalanced(null);
                    setBalanceDifference("");
                    setHead05ClosingDebit("");
                    setHead05ClosingCredit("");
                    setTotalMessage(response.data.status_message || "No data found.");
                    if (response.data.status_code === 2) {
                        toast.error(response.data.status_message || "Failed to load receipt payment data.");
                    }
                }

            })
            .catch(function (error) {
                toast.error("Failed to load receipt payment data.");
            })
            .finally(function () {
                setLoading(false);
            });

    }, [DefaultFYear, AccountLevel, EndDate, showZeroAccounts, showThirdOnly, searchTrigger]);

    const renderRows = (items, isOpening) => {
        if (!items || items.length === 0) {
            return (
                <tr>
                    <td colSpan="4">
                        <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                            No Data Found
                        </h4>
                    </td>
                </tr>
            );
        }
        return items.map((item, index) => {
            const code = item.Selected_Account?.Account_code || "";
            const rowStyle = code.length === 2
                ? { backgroundColor: "#fddede" }
                : code.length === 5
                    ? { backgroundColor: "#d9f7fe" }
                    : undefined;
            return (
                <tr key={index} style={rowStyle}>
                    <td>
                        <NavLink to={`/Accounts/GeneralLedger/${item.Selected_Account.Account_code}?FYear=${DefaultFYear || ""}`}>
                            {item.Selected_Account.Account_code}
                        </NavLink>
                    </td>
                    <td>{item.Selected_Account.Account_desc}</td>
                    {isOpening ? (
                        <>
                            <td className="text-end">{item.OpeningDebit}</td>
                            <td className="text-end">{item.OpeningCredit}</td>
                        </>
                    ) : (
                        <>
                            <td className="text-end">{item.ClosingCredit}</td>
                            <td className="text-end">{item.ClosingDebit}</td>
                        </>
                    )}
                </tr>
            );
        });
    };

    const fyMaxEndDate = (() => {
        const fy = parseInt(String(DefaultFYear || "").trim(), 10);
        if (!Number.isFinite(fy) || fy <= 0) {
            return moment().format(config.date_format_input);
        }
        const fyEnd = moment(`${fy + 1}-03-31`);
        const today = moment();
        return (today.isBefore(fyEnd, "day") ? today : fyEnd).format(config.date_format_input);
    })();

    const fyMinEndDate = (() => {
        const fy = parseInt(String(DefaultFYear || "").trim(), 10);
        if (!Number.isFinite(fy) || fy <= 0) {
            return "";
        }
        return moment(`${fy}-04-01`).format(config.date_format_input);
    })();

    return (
        <>
            <AccountsMenu />
            <ToastContainer />
            <div className="container body-content">

                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Receipt Payment</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Receipt Payment</div>
                            </div>
                            <div className="col-md-6">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body p-md-4">
                                <div className='row align-items-center gy-3'>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="">Financial Year:</label>
                                            <select
                                                className="form-select"
                                                value={DefaultFYear || ""}
                                                onChange={(e) => {
                                                    setDefaultFYear(e.target.value);
                                                }}
                                            >
                                                <option value="">Select Year</option>
                                                <YearsDropDown />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="">Select Level:</label>
                                            <select className="form-select" value={AccountLevel} onChange={(e) => setAccountLevel(e.target.value)} >
                                                <option value="1">1st Level</option>
                                                <option value="2">2nd Level</option>
                                                <option value="3">3rd Level</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="">As On:</label>
                                            <input
                                                type="date"
                                                width="200"
                                                className="form-control"
                                                value={EndDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                required
                                                min={fyMinEndDate}
                                                max={fyMaxEndDate}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <div className="form-check mt-md-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="flexCheckZeroAccounts"
                                                    checked={showZeroAccounts}
                                                    onChange={(e) => setShowZeroAccounts(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="flexCheckZeroAccounts">
                                                    Show Zero Accounts:
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <div className="form-check mt-md-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="flexCheckThirdOnly"
                                                    checked={showThirdOnly}
                                                    onChange={(e) => setShowThirdOnly(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="flexCheckThirdOnly">
                                                    Show 3rd Level Only:
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2 text-end">
                                        <div className="form-group mt-md-4">
                                            <input type="button" value="Search"
                                                className="button button-primary"
                                                onClick={() => setSearchTrigger((prev) => prev + 1)}
                                            />
                                            <NavLink
                                                target="_blank"
                                                className="button button-primary ms-2"
                                                to={`/Accounts/PrintReceiptPayment?FYear=${DefaultFYear || ""}&EndDate=${EndDate || ""}&AccountLevel=${AccountLevel || 1}&ShowZeroAccounts=${showZeroAccounts ? "1" : "0"}&ShowThirdOnly=${showThirdOnly ? "1" : "0"}`}
                                            >
                                                Print
                                            </NavLink>
                                            <input type="button" value="Transfer As Opening Balance"
                                                className="button button-white d-none"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {totalMessage && (
                            <div className="alert alert-warning mt-2 mb-0">
                                {totalMessage}
                            </div>
                        )}
                        <div className="card mt-2">
                            <div className="card-body">
                                <p className="text-muted small mb-3">
                                    <strong>Note:</strong> Includes account heads <strong>04</strong> and <strong>07</strong> (payments),{" "}
                                    <strong>05</strong> (opening/closing cash), and <strong>06</strong> (receipts) only.
                                    Footer totals use 3rd-level accounts to avoid double-counting.{" "}
                                    <NavLink to="/Accounts/TrialBalanceHeadWise">
                                        Compare with Trial Balance (Head 05 cash/bank)
                                    </NavLink>
                                </p>
                                <table className="table table-theme table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Account Code</th>
                                            <th>Account Name</th>
                                            <th colSpan="2" className="text-center">Closing</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th className="text-center">Debit</th>
                                            <th className="text-center">Credit</th>
                                        </tr>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="4">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan="4"><h5>OPENING BALANCE</h5></td>
                                                </tr>
                                                {renderRows(listOfOpening, true)}
                                                <tr>
                                                    <td colSpan="4"><h5>RECEIPTS</h5></td>
                                                </tr>
                                                {renderRows(listOfReceipts, false)}
                                                <tr>
                                                    <td colSpan="4"><h5>PAYMENTS</h5></td>
                                                </tr>
                                                {renderRows(listOfPayments, false)}
                                                <tr>
                                                    <td colSpan="4"><h5>CLOSING BALANCE</h5></td>
                                                </tr>
                                                {renderRows(listOfClosing, false)}
                                                <tr>
                                                    <td colSpan="2" className="text-end">Totals (3rd level)</td>
                                                    <td className="text-end">{ClosingDebitTotal}</td>
                                                    <td className="text-end">{ClosingCreditTotal}</td>
                                                </tr>
                                                {isBalanced !== null && (
                                                    <tr>
                                                        <td colSpan="4" className={isBalanced ? "text-success" : "text-danger"}>
                                                            {isBalanced
                                                                ? "Balanced: Total Debit equals Total Credit."
                                                                : `Not balanced. Difference (Debit − Credit): ${balanceDifference}`}
                                                        </td>
                                                    </tr>
                                                )}
                                                {(head05ClosingDebit || head05ClosingCredit) && (
                                                    <tr>
                                                        <td colSpan="4" className="text-muted small">
                                                            Head 05 closing for reconciliation — Debit: {head05ClosingDebit}, Credit: {head05ClosingCredit}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReceiptPayment;